const TOPICS_LIST = [
  { label: '韩漫推荐', hot: true },
  { label: '免费韩漫', hot: true },
  { label: '韩漫之家', hot: true },
  { label: '韩漫屋', hot: false },
  { label: '韩漫网入口', hot: true },
  { label: '恋爱韩漫', hot: false },
  { label: 'BL韩漫', hot: true },
  { label: '新番速递', hot: true },
  { label: '韩漫在线', hot: false },
  { label: '热血韩漫', hot: false },
  { label: '韩漫网址', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            当前韩漫社区最受关注的热门话题与标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS_LIST.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              {topic.label}
              {topic.hot && (
                <span className="text-[10px] text-accent-600">热门</span>
              )}
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-fire-line text-accent-500"></i>
            以上话题基于近期韩漫网站访问热度统计，每日更新
          </span>
        </div>
      </div>
    </section>
  );
}